/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum EquipmentSyntheticSleepStatuses {

    PendingActivation = 'PendingActivation',

    Active = 'Active',

    RestoreRequested = 'RestoreRequested',

    Restored = 'Restored',

    Failed = 'Failed',

    Expired = 'Expired',

    PoolsChangedExternally = 'PoolsChangedExternally'
}

